export default "__VITE_ASSET__BSuTHkfS__"